import type React from 'react';

import { PageLoader } from '@crehana/compass.ui/v2';
import { useFeatureFlag } from '@crehana/feature-flags/react';

import type { DiplomasProps } from '@/shared/components';

import DiplomasSection from './DiplomasSection';
import DiplomasPageNew from './diplomas-page-new';

const CertificatesCollaboratorPage: React.FC<DiplomasProps> = ({
  ...props
}) => {
  const { flagValue: isEnabled, loading } = useFeatureFlag(
    'LEARNING_MIGRATE_USER_CERTIFICATE_QUERY',
  );

  if (loading) {
    return <PageLoader />;
  }

  if (!isEnabled) {
    return <DiplomasSection {...props} />;
  }

  return <DiplomasPageNew {...props} />;
};

export default CertificatesCollaboratorPage;
